import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { PlayerContext } from "../../PlayerContext";
import { checkMobile } from "../../Utils";
import { Image } from "react-native-web";
import CloseButton from "../../side_menu/components/CloseButton";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { IconButton } from "@mui/material";
import { Cancel } from "@mui/icons-material";

function Promotion(props){
    const { t } = useTranslation();
    const playMode = useContext(PlayerContext).get("playMode");
    const storyDimensions = useContext(PlayerContext).get("storyDimensions");
    const sizeMultiplier = useContext(PlayerContext).get("sizeMultiplier"); 
    
    return (
        <div style={{pointerEvents: 'auto'}}>                       
            <div id="promotion-container" className={'promotion-container'} style={{width: storyDimensions.containerWidth, height: storyDimensions.containerHeight,}}>                                                                
                {playMode === "preview" && !checkMobile() && <div style={{width: 1, height: storyDimensions.containerHeight, backgroundColor: '#b2ede7', position: 'absolute', left: 0, bottom: 0}} />}                 
                <div className="FullScreenContainer" style={{backgroundColor: props.story.promotionBackground}}>              
                    <TransformWrapper>
                        <TransformComponent>
                            <img alt={t('FullScreenPromotionAlt')} src={props.story.promotionImgUrl} style={{objectFit: "contain", width: storyDimensions.containerWidth, height: storyDimensions.containerHeight}}/>
                        </TransformComponent>
                    </TransformWrapper>                              
                </div>                 
                <div style={{position: 'absolute', zIndex: 30, pointerEvents: "auto", top: storyDimensions.containerHeight - 48 * sizeMultiplier - 16 * sizeMultiplier, left: storyDimensions.containerWidth - 16 * sizeMultiplier - 48 * sizeMultiplier - 8 * sizeMultiplier }}>                    
                    <IconButton aria-label="page right" style={{width: 64 * sizeMultiplier, height: 64 * sizeMultiplier}} onClick={props.close}>
                        <Cancel style={{color: props.story.primaryColor, width: 48 * sizeMultiplier, height: 48 * sizeMultiplier}}/>
                    </IconButton>
                </div>
            </div>
        </div>
    );
}  

export default Promotion;